import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <img
        src="/image copy copy copy.png"
        alt="Siscaro Property Solutions"
        className="h-8 md:h-10"
      />
    </div>
  );
}

export default Logo;